import { Component, OnInit, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ChartData } from "chart.js";
import { color } from "d3";
import { CrudService } from "src/app/Services/crud.service";

@Component({
  selector: "app-usage-analytic-detail",
  templateUrl: "./usage-analytic-detail.component.html",
  standalone: false,
})
export class UsageAnalyticDetailComponent implements OnInit {
  ratingCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  @Input() isAnalytics: any;
  barChartOptions = {
    responsive: true,
    indexAxis: "y", // makes it horizontal
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "#000", // x-axis labels color
        },
      },
      y: {
        ticks: {
          color: "#000", // y-axis labels color
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          color: "#000", // legend text color
        },
      },
    },
  };

  barChartLabels = ["5", "4", "3", "2", "1"];

  barChartType = "bar"; // always 'bar' in Chart.js v4
  barChartLegend = true;

  barChartData: ChartData<"bar"> = {
    labels: ["5", "4", "3", "2", "1"],
    datasets: [
      {
        data: [], // start empty
        label: "Rating Count",
        backgroundColor: "#032d55",
        hoverBackgroundColor: "#2083e9",
        borderColor: "#ffffff",
        hoverBorderColor: "#2083e9",
      },
    ],
  };
  rate = {};
  chartOptions = {
    responsive: true,
    indexAxis: "x",
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "#000", // categories color
        },
        title: {
          display: true,
          text: "Response Length", // 👈 X axis label
          color: "#000",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#000", // count color
        },
        title: {
          display: true,
          text: "Count", // 👈 Y axis label
          color: "#000",
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          color: "#000", // legend text color
        },
      },
    },
  };
  chartLabels = ["5", "4", "3", "2", "1"];
  chartType = "bar";
  chartLegend = true;

  chartData: ChartData<"bar"> = {
    labels: ["5", "4", "3", "2", "1"],
    datasets: [
      {
        data: [0, 0, 0, 0, 0], // start empty
        label: "Rating Count",
        backgroundColor: "#032d55",
        hoverBackgroundColor: "#2083e9",
        borderColor: "#ffffff",
        hoverBorderColor: "#2083e9",
      },
    ],
  };

  title = "";
  analyticsChartTitle = "";
  thumbsUpCount = 0;
  thumbsDownCount = 0;

  constructor(
    public dialogRef: MatDialogRef<UsageAnalyticDetailComponent>,
    private translateService: TranslateService,
    private crudService: CrudService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);

    this.isAnalytics ??= data.isAnalytics ?? false;
    console.log("incoming data here", data);
    this.getData(data.response);
    if (data.isAnalytics && data.response && data.response.length == 1) {
      this.getFeedbackInDetail(data);
    }
    if (data.isAnalytics && data.response && data.response.length > 1) {
      this.getDataForAll(data.response);
    }
  }

  ngOnInit() {}

  getFeedbackInDetail(ref) {
    this.title = `${
      ref.refType === "workflow" || ref.refType === "userguide"
        ? ref.refType.charAt(0).toUpperCase() + ref.refType.slice(1)
        : ref.refType
    } - ${ref.refName}`;
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          response.forEach((item) => {
            this.ratingCounts[item.rating]++;
            if (item.thumbsUp) this.thumbsUpCount++;
            if (item.thumbsDown) this.thumbsDownCount++;
          });
          this.barChartData = {
            labels: this.barChartLabels,
            datasets: [
              {
                data: [
                  this.ratingCounts[5],
                  this.ratingCounts[4],
                  this.ratingCounts[3],
                  this.ratingCounts[2],
                  this.ratingCounts[1],
                ],
                label: "Rating Count",
                backgroundColor: "#032d55",
                hoverBackgroundColor: "#2083e9",
                borderColor: "#ffffff",
                hoverBorderColor: "#2083e9",
              },
            ],
          };
        }
      },
      "feedbacks?filter[where][refId]=" + ref.refId
    );
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  getData(data) {
    this.analyticsChartTitle = `${
      data.docType === "workflow" || data.docType === "userguide"
        ? data.docType.charAt(0).toUpperCase() + data.docType.slice(1)
        : data.docType
    } - ${data.docName}`;

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length) {
          const len = response.length;
          this.rate[len] = (this.rate[len] || 0) + 1;

          // Find the maximum key so we know the full range
          const maxKey = Math.max(
            ...Object.keys(this.rate).map((k) => parseInt(k))
          );

          // Build labels and data for 1..maxKey
          const labels = Array.from({ length: maxKey }, (_, i) =>
            (i + 1).toString()
          );
          const data = labels.map((l) => this.rate[parseInt(l)] || 0);

          this.chartData = {
            labels: labels,
            datasets: [
              {
                label: "Rating Count",
                data: data,
                backgroundColor: "#032d55",
                hoverBackgroundColor: "#2083e9",
                borderColor: "#ffffff",
                hoverBorderColor: "#2083e9",
                barPercentage: 0.5,
                categoryPercentage: 0.7,
              },
            ],
          };
        }
      },
      `usageAnalytics?filter[where][docId]=${data.docId}&filter[where][type]=chat`
    );
  }

  getDataForAll(data) {
    var docIds = [];

    data.forEach((item) => {
      this.analyticsChartTitle = `${
        item.docType === "workflow" || item.docType === "userguide"
          ? item.docType.charAt(0).toUpperCase() + item.docType.slice(1)
          : item.docType + "S"
      }`;
      console.log("individual docId here", item.docId);
      if (!docIds.includes(item.docId)) {
        docIds.push(item.docId);
      }
    });
    let url = "usageAnalytics?";
    docIds.forEach((id, index) => {
      url += `filter[where][docId][inq][${index}]=${id}&`;
    });
    url += "filter[where][type]=chat";
    console.log("docids here", docIds);
    this.crudService.get(
      null,
      (response) => {
        console.log("response here for get all", response);
        if (response && response.length) {
          const len = response.length;
          this.rate[len] = (this.rate[len] || 0) + 1;
          const keys = Object.keys(this.rate)
            .map((k) => parseInt(k))
            .sort((a, b) => b - a); // descending
          const labels = keys.map((k) => k.toString());
          const data = keys.map((k) => this.rate[k]);

          console.log("labels here", labels);
          console.log("data here", data);
          this.chartData = {
            labels: labels,
            datasets: [
              {
                label: "Rating Count",
                data: data,
                backgroundColor: "#032d55",
                hoverBackgroundColor: "#2083e9",
                borderColor: "#ffffff",
                hoverBorderColor: "#2083e9",
              },
            ],
          };
        }
      },
      url
      // `usageAnalytics?filter[where][docId][inq]=${docIds}&filter[where][type]=chat`
    );
  }
}
